import React, { useContext, useState, useEffect } from 'react'
import '../../styles/preparepdf.css'


import { ShareContext } from '../../context/ShareContext'


import { useNavigate, useLocation, Link } from 'react-router-dom'
import * as Constants from '../../constants';

import BackLoader from '../../components/backloader'
import Seal from '../../assets/seal.png';
import Sign2 from '../../assets/sign.png';
import { Button } from '@mui/material'
import JisPrompt from '../../components/jisprompt'
import JisAlert from '../../components/jisalert'

import { green, red } from '@mui/material/colors'
import moment from 'moment'
import DynamicIcon from '../dynamicicon'
import JisButton from '../controls/jisButton';
import JisDialog from '../dialog';
import JisDialogForm from '../formdialog';


function JisPrepareTemplatePlain({templatedoc,docInfo, isLegal=true, doctype="document", autoFill=[], onDone,onChange}) {
    const {isThirdOpt, setWhichUpload, profile,token,frequentData,setIsExpired } = useContext(ShareContext)
 
/*   console.log('auto fill in template')
  console.log(autoFill); */
    var item = docInfo;
 
    const urlSaveInst = `${Constants.apiUrl}/filing/uploadtemplate`;
    const urlInstrument=`${Constants.apiUrl}/filing/instrument`;
    const [html, setHtml] =useState('');
 
    const [holders, setHolders] =useState([])
    const [holdervalues, setHolderValues]=useState({});
    const [presentTag, setPresentTag] = useState(new Set());
    const [upload, setUpload] = useState({open:false,title:'', id:0} );

    const pattern= /\[.+?\]/g

    const affidavit_search_prefix='LSJ/HC/AFF';
    const [cfoWarn, setCfoWarn] = useState(false)
    const [isDialog, setIsDialog] = useState(false)
    const [doc, setDocument] =useState({uplines:[],uplinesigns:[]})
    const [currectdoc, setCurrentDoc]=useState(templatedoc);
    const [uplineIndex, setUplineIndex]=useState(0);

    const [isLoading,setIsLoading]= useState(false);
   
    const [seal, setSeal]=useState('');
    const [passport, setPassport] =useState('');
    const [sign, setSign] =useState('');
    const [initial, setInitial] =useState('');
    const [stamp, setStamp] =useState('');
    const [fAutoFill, setfAutoFill] = useState(autoFill)
    
     //load documents first, then load one by one
   const [posId, setPosId] =useState(0); //this is the main guy that is doing the selection
   const [dstart, setDStart]=useState({isDragging: false});
   const [imgs, setImgs]=useState([]);
   const [activeFile,setActiveFile] =useState({});
   const [isSaved, setIsSaved] =useState(true);
   const [allDocCompleted, setAllDocCompleted]=useState(false); //this is to receive the server answer to know when last part is finally treated
   const [activeSub, setActiveSub]=useState({open:false});
   const [refresh, setRefresh]=useState(false);
   const [permissionList, setDocPermissionList]=useState(new Set());


   const needpermission="Document saved successfully! Wait for the CFO to commission your document ";
   const noneedpermission="Document saved successfully! Wait for the CFO to initial your document";
   const finalmsgcase=`You have worked on all document(s), the case will now move to Process Section Assessors' Queue `;
   const finalmsgaffidavit="You have worked on the affidavit. The process is completed now";
   const finalmssheriff=`Document processed successfully! You have worked on Service Sheriff affidavit. `;
   const finalsettlement=`Term of settlement processed successfully! `;
   //const permissionList=item.caseType=='adr'?Constants.DocPermissionList_ADR:Constants.DocPermissionList;


   const onSaveInst=()=>{
    if(!upload.isImage)
        return;

        onUploadIns();
   }

   const [imgPrev, setImgPrev]=useState ({data:'', type:'', open:false});

   const [alert, setAlert]=useState ({open:false,title:'', subtitle:''})
   const [prompt, setPrompt]=useState ({open:false,title:'', subtitle:'', isImage:false})

    const navigate = useNavigate()

 const onOk=()=>{
    setAlert({...alert,open:false});
    console.log('on going to redireck Ok');
   console.log(item);

  /*   if(item.type=='sheriff'){
        navigate("/cfo-e-swearing-sheriff");
       } */
 }
 const onOk_Save=()=>{

    console.log('on going to onOk_Save');
   console.log(item);

    setAlert({...alert,open:false});
    if(item.type=='affidavit'){
        navigate("/affidavits");
       }
   if(item.type=='sheriff'){
        navigate("/cfo-e-swearing-sheriff");
       }

       if (typeof onDone === "function") {
        console.log('called onDone in the component')
        onDone(currectdoc);
        }else{
            console.log(typeof onDone)
        }
 }
 const onCancel=()=>{

 }

  

    const confirmCaseDoc = () => {
        navigate('/upload/documents');
        setWhichUpload('Third')
    }

 useEffect(() => {
    console.log('autofill already changed');
    console.log(autoFill);
    if(!(autoFill==null || autoFill.length==0)){
        console.log('autlofill updated');
        setfAutoFill(autoFill)    
    }
           
    }, [autoFill]);

    useEffect(() => {
   
         onChange(holdervalues,html,isLegal)  
    }, [holdervalues,html,isLegal]);

    useEffect(() => {
       // onLoad();
             //  console.log('in the preparetemplate ***************')
             if(holders.length>0) //so this is load once only
                return;

               setCurrentDoc(templatedoc);
                onLoadInstrument();
               // onLoadPermissions();
            //   var ftempid= currectdoc.upline.templateId;
             var temp=templatedoc.template;
               // var htmlstr=atob(temps[ftempid].html);
                var htmlstr=Constants.b64decode(temp?.html);
                 setHtml( htmlstr);
                 
                 //console.log('the html is set');
                 setHolderValues({});
                 
                 const tags = Array.from(htmlstr.match(pattern))
                 setPresentTag(new Set( tags ) );
                onTemplateHolder(temp.id);
        
 
      }, [templatedoc]);


    const onTemplateHolder= async(tempid)=>{
        const temprl=`${Constants.apiUrl}/filing/templates/${tempid}/holders`;
       // console.log(`the calling url ${temprl}`);
        try {
            setIsLoading(true);
            const resp = await fetch(temprl, { 
              method: 'GET',
              headers: {
                'Content-Type': 'application/json',
                 Authorization: `Bearer ${token}`,
              },
            });
            
            const data = await resp.json();
           // console.log(data);
            setIsLoading(false);
            if(data.code==0){
                setHolders(data.holders);
            }
            
          } catch (error) {
            setIsLoading(false);
            console.error(error);
            
          }
    }

 
    const previewImage= async (event)=> {
        //console.log("file read");
        const input = event.target;
       // setUpload upload
      //  console.log(input);
        if (input.files && input.files[0]) {
            var b64=await Constants.toBase64(input.files[0]);
            setUpload({...upload, isImage:true,data:b64, file:input.files[0]})
        }
      }

  
      const onUploadIns= async()=>{
   //     console.log('imgPrev data');
      //  console.log(upload);
            setIsLoading(true);    
        //setImgPrev({...imgPrev,open:true,data:e.target.result,type:inst, title:"Upload "+inst, });
            var ext=upload.file.name?.split('.')[1];
            var rdata={base64: upload.data?.split(',')[1],ext,holderId:upload.id};
            // Sending the FormData using fetch
            fetch(urlSaveInst, {
            method: 'POST',
            body: JSON.stringify(rdata),
            headers: {
              'Content-Type': 'application/json',
               Authorization: `Bearer ${token}`,
            },
            })
            .then(response => response.json())
            .then(data => {
                setIsLoading(false); 
                if(data.code==0){
                    //saved already
                   //get the real url and attach to the holdervalues of same id and check if value exist to display instead of displaying default
                  // console.log(`the holder  ${upload.id}`)
                   var hv={...holdervalues};
                   var row=hv[upload.id];
                  const filename= `${Constants.docUrl}holdermedia/${data.filename}`
                   if(row==null){
                       hv[upload.id]={...upload.holder, value:filename, type:'media'};
                   }else{
                       hv[upload.id]={...row,  value:filename, };
                   }
                 
                   setHolderValues(hv);
                //   console.log(hv);
                   setUpload({open:false})
                   replaceTemplate(hv);
                }else if(data.code==-10){
                      setIsExpired(true);
                  }
            })
            .catch(error => {
                console.error('Error:', error)
                setIsLoading(false); 
            });
    }

  
    const onSetImg =(path,type)=>{
        const ct=type.toLowerCase()
        if(ct=='seal'){
            setSeal(  `${Constants.docUrl}instrument/${path}`);
        }else if(ct=='passport'){
            setPassport(  `${Constants.docUrl}instrument/${path}`);
        }else if(ct=='signature'){
            setSign(  `${Constants.docUrl}instrument/${path}`);
        }
        else if(ct=='initial'){
            setInitial(  `${Constants.docUrl}instrument/${path}`);
        }else if(ct=='stamp'){
            setStamp(  `${Constants.docUrl}instrument/${path}`);
        }
    }

    const onLoadInstrument = async()=>{
        //for account registration
      //  console.log(`the calling url ${urlInstrument}`);
        try {
            setIsLoading(true);
            const resp = await fetch(urlInstrument, { 
              method: 'GET',
              headers: {
                'Content-Type': 'application/json',
                 Authorization: `Bearer ${token}`,
              },
            });
            
            const data = await resp.json();
            setIsLoading(false);
            if(data.code==0){
                //check if it contain any of the items
            //    console.log(data);
                for( const x of data.inst ){
                    onSetImg(x.instPath, x.instrument)
                }
                
            }
            
          } catch (error) {
            setIsLoading(false);
            console.error(error);
            
          }
    }


    const onAddList =(holder)=>{
        var hv={...holdervalues};
            var row=hv[holder.id];
            if(row.listobj==null){
                row.listobj=[];
            }
            //row.listobj.push(row.value);
            //row.value=''; //empty the content
        //    console.log(row.value);
            hv[holder.id]={...row,listobj:[...row.listobj,row.value], value:''};
            setHolderValues(hv);
            replaceTemplate(hv);
       
    }
    const onRemoveList=(holder,idx)=>{
        var hv={...holdervalues};
        var row=hv[holder.id];
        
        var list= row.listobj;
        list.splice(idx, 1)
        //row.listobj.push(row.value);
        //row.value=''; //empty the content
      
        hv[holder.id]={...row,listobj:[...list], value:''};
        setHolderValues(hv);
        replaceTemplate(hv);
    }
    const onEditList=(holder,idx)=>{
        var hv={...holdervalues};
        var row=hv[holder.id];
        
        var list= row.listobj;
      
        hv[holder.id]={...row, value:list[idx].value,editindex:idx};
      //  console.log('something about index '+idx)
      //  console.log(hv[holder.id]);
        setHolderValues(hv);
        replaceTemplate(hv);
    }

    const onAddPara =(holder)=>{
        
        var hv={...holdervalues};
            var row=hv[holder.id];
     if(row.editindex==null)  {
        if(row.listobj==null){
                row.listobj=[];
            }
           // row.listobj.push(row.value);
            //row.value=''; //empty the content
         //   console.log(row.value);
            const ovalue={value:row.value,sub:[]}
            hv[holder.id]={...row,listobj:[...row.listobj,ovalue], value:''};
          //  console.log(hv[holder.id].listobj);
     } else{
        //edit
        row.listobj[row.editindex]={...row.listobj[row.editindex],value:row.value};
        hv[holder.id]={...row, value:'',editindex:null};
     }   
            
            setHolderValues(hv);
            replaceTemplate(hv);
            
    }
    const onAddSubPara =()=>{
//relies on activeSub holder, ind, idx
const idx=activeSub.idx;
//console.log(`index of the item ${idx} value to add ${activeSub.value}`)
        var hv={...holdervalues};
            var row=hv[activeSub.holder.id];
            var list= row.listobj;
            var li= list[idx];
            //li.value, li.subs
            if(li.subs==null){
                li.subs=[activeSub.value];
            }else{
                li.subs=[...li.subs,activeSub.value]
            }
            list[idx]={...li,subs:li.subs}
            row={...row,listobj:list}
           
            //row.value=''; //empty the content
            hv[activeSub.holder.id]={...row};
            setHolderValues(hv);
setActiveSub({open:false});
       replaceTemplate(hv);
    }
    const onRemoveSubList=(holder,idx,idxx)=>{
        var hv={...holdervalues};
        var row=hv[holder.id];
        var list= row.listobj;
        var li= list[idx];
        
        li.subs.splice(idxx, 1);
        list[idx]={...li,subs:li.subs}
        row={...row,listobj:list}
       
        //row.value=''; //empty the content
        hv[holder.id]={...row};
       
        setHolderValues(hv);
        replaceTemplate(hv);
    }

    const onAppending=(holder)=>{
        if(holder.dataType=='UPLOADED MEDIA[SEAL-COMISSIONER]' || holder.dataType== "UPLOADED MEDIA[SEAL-DEPONENT]"){ //for seal
            if(isLegal){
                if((permissionList.has(currectdoc?.upline?.gazetteItemId) || item.type=='affidavit') && !currectdoc?.upline?.allowSeal){
                    setAlert(  {icon:'warning',open:true,title:'Append ', subtitle:'Wait for the CFO to authorize appending a seal on the document. This approval will be granted during the scheduled virtual call', onOk});
                  return;
                } 
               }else{
                if((permissionList.has(currectdoc?.upline?.gazetteItemId) || item.type=='affidavit') && !currectdoc?.upline?.allowSeal){
                    setAlert(  {icon:'warning',open:true,title:'Append ', subtitle:'Allow Legal Counsel to append seal before you. use the back link and re-open', onOk});
                  return;
                } 
               }
            }
    
            if(holder.dataType=='UPLOADED MEDIA[SIGNATURE-DEPONENT]' || holder.dataType=="UPLOADED MEDIA[SIGNATURE-COMISSIONER]"){
                if((permissionList.has(currectdoc?.upline?.gazetteItemId) ||  item.type=='affidavit') && !currectdoc?.upline?.allowSign){
                    //  setAlert(  {open:true,title:'Append ', subtitle:'Wait for the CFO to authorize appending a signature on the document. This approval will be granted during the scheduled video virtual call". if you are sure the CFO has approved. Please click Next and Previous to the same file to refresh', onOk});
                   setAlert(  {icon:'warning',open:true,title:'Append ', subtitle:'Wait for the CFO to authorize appending a signature on the document. This approval will be granted during the scheduled virtual call', onOk});
                    return;
                  } 
            }

        setUpload({open:true, title:holder.name, id:holder.id, holder , isImage:false});
    }

    const returnTag=(holder, ind)=>{
        var hv={...holdervalues};

        const m = fAutoFill?.find((d) => d.holder === holder.holder);
        if(m){
           // const m= autoFill.filter((d)=>d.holder==holder.holder)[0]
          // console.log(`${m.value} holder: ${holder.holder}`);

             if(hv[holder.id]==null){
                hv[holder.id]={...holder, value:m.value, type:'single'};
               setHolderValues(hv);
                replaceTemplate(hv); 
            }  
        }
        else if (holder.holder=='[DIVISION]' && item?.division!=null){
        //AUTO ADDED TO PROJECT. ITS AN IMAGE
        if(hv[holder.id]==null){
                hv[holder.id]={...holder, value:item.division, type:'single'};
               setHolderValues(hv);
             replaceTemplate(hv); 
            }  
    }else if (holder.holder=='[SUIT_NO]' && item?.caseNumber!=null){
        //AUTO ADDED TO PROJECT. ITS AN IMAGE
        var row=hv[holder.id];
        if(hv[holder.id]==null){
                hv[holder.id]={...holder, value:item.caseNumber, type:'single'};
               setHolderValues(hv);
             replaceTemplate(hv); 
            }
 
    }
    else if (holder.dataType=='TEXT[NORMAL]'  ){
        return  <div className="input-create">
        <label htmlFor="doc-title">{holder.name} </label>
        <input type="text"  placeholder={holder.hint} value={onGetValue(holder)} onChange={(e)=> onDirectText(e,holder)} />
    </div>
        

    }else if (holder.dataType=='TEXT[MULTIPLE-INPUT]'){
        return <div className="input-create">
        <label htmlFor="defendant">{holder.name}</label>
        <div className="btn-input">
            <input type="text"  placeholder={holder.hint} value={onGetValue(holder)} onChange={(e)=> onDirectTextMultiple(e,holder,ind)}/>
            <button onClick={()=>onAddList(holder)}> Add <DynamicIcon iname='plus_circle'/></button>
        </div>
        <ul className='temp'>
        {hv[holder.id]!=null && hv[holder.id].listobj?.map((li, idx) => { return (
                                           <li key={idx}> <div className="content">
                                            {li}
                                           
                                           </div>
                                           <div className="action">
                                           <div className="icon" onClick={() => onRemoveList(holder,idx)} >
                                                             <DynamicIcon iname='close'/>
                                                           </div>
                                           </div></li>
                                
                                        )})}
        </ul>
    </div>
      
    } else if (holder.dataType=='CFO-DATE' ||holder.dataType=='[CFO-DATE]' || holder.dataType=='[COUNSEL-DATE]' || holder.dataType=='COUNSEL-DATE' || holder.dataType=='[DATE]'){

        return  <div className="input-create">
        <label htmlFor="doc-title">{holder.name}</label>
        <input type="date"  placeholder={holder.hint} value={onGetValue(ind)} onChange={(e)=> onDirectText(e,holder)} />
    </div>

    } else if (holder.dataType=='[CFO-DATE-TIME-STAMP]' || holder.dataType=='CFO-DATE-TIME-STAMP' || holder.dataType=='[DATE-TIME-STAMP]' ){

        return  <div  className="append">
        <label htmlFor="doc-title" style={{fontWeight:'bold'}}>{holder.name} </label>
        <button onClick={()=>onTimeStamp(holder)} className='planred'>Append Timestamp</button>
    </div>

    }else if (holder.dataType=='TEXT[LEGAL-COUNSEL-CONTACT]' ||holder.dataType=='TEXT[DETAIL-AND-SERVICE-ADDRESS-SECTION]'){
        return  <div className="input-create">
        <label htmlFor="doc-title">{holder.name} </label>
        <textarea id="paragraph" placeholder={holder.hint} value={onGetValue(holder)} onChange={(e)=> onDirectText(e,holder)} ></textarea>
    </div>
    }
    else if (holder.dataType=='TEXT[MULTIPLE-TEXTAREA]' ){
        return <div className="input-create">
        <label htmlFor="paragraph">{holder.name}</label>
        <div className="btn-input">
            <textarea id="paragraph" placeholder={holder.hint} value={onGetValue(holder)} onChange={(e)=> onDirectAreaMultiple(e,holder,ind)}></textarea>
            <button  onClick={()=>onAddPara(holder)}>{Constants.IsNull(holdervalues[holder.id]?.editindex)?'Add':'Update'} 
                
                <DynamicIcon iname={Constants.IsNull(holdervalues[holder.id]?.editindex) ?'plus_circle':'edit'}/>
                </button>
        </div>
        <ul className='temp'>
            {hv[holder.id]!=null && hv[holder.id].listobj?.map((li, idx) => { return (
                      <li key={idx}>
                        <div className="content">{li.value}
                        <div style={{marginLeft:16, marginRight:16}}>
                        {li.subs!=null && li.subs?.map((sub, idxx) => { return (
                                           <div key={idxx} stlye={{ backgroundColor:'#ccc'}}> <div className="content">
                                           {Constants.getAlphaByNum(idxx+1) }). {sub}
                                           
                                           </div>
                                           <div className="action">
                                           <div className="icon" onClick={() => onRemoveSubList(holder,idx,idxx)} >
                                                               <DynamicIcon iname='close'/>
                                                           </div>
                                           </div></div>
                                
                                        )})}
                        </div>
                        </div>
                        <div className="action">
                        <div className="icon" style={{marginLeft:16}} onClick={() => onEditList(holder,idx)} >
                                <DynamicIcon iname='edit'/> Edit 
                            </div>
                            <div className="icon" style={{marginLeft:16}} onClick={() => onRemoveList(holder,idx)} >
                                 <DynamicIcon iname='close'/> Del 
                            </div>
                            <div className="icon" style={{marginLeft:16}} onClick={() => setActiveSub({open:true, holder,idx, title:'Sub Paragraph'})} >
                                <DynamicIcon iname='plus_circle'/>  Sub
                            </div>
                        </div>
                          </li>
                                
             )})}
        </ul>
    </div>
      
    } 
    else if (holder.dataType=='UPLOADED MEDIA[SIGNATURE-DEPONENT]' ||
     holder.dataType=='UPLOADED MEDIA[SEAL-COMISSIONER]' || 
     holder.dataType=='UPLOADED MEDIA[STAMP-COMISSIONER]' || holder.dataType== 'UPLOADED MEDIA[PASSPORT]' 
     || holder.dataType== "UPLOADED MEDIA[SEAL-DEPONENT]"
     || holder.dataType=="UPLOADED MEDIA[SIGNATURE-COMISSIONER]" || (holder.dataType=="UPLOADED MEDIA[IMAGE]" && (holder.holder!='[QR-CODE]' && holder.holder!='[CASHIER_SEAL]' && holder.holder!='[CASHIER_STAMP]')))
     {
        const ss=checkMedia(holder);
       return <div className="append">
        <img src={ holdervalues[holder.id]==null?  (ss.status?ss.imgPath: Seal): holdervalues[holder.id]?.value} alt="Instrument" style={{width:100}} />
        <div className='buttongrp'>
           {ss.status && <div><button className='black' onClick={()=>onAppendStoreImg(holder,ss.imgPath)}>Use this {ss.dataType}</button></div>} 
            <div className="append-create"  onClick={() =>onAppending(holder) } >
         
            <label htmlFor="append-seal">{ss.status? `Choose Another ${ss.type}`: holder.name}</label>
        </div>
        </div>
        
    </div>
    }
    //** the are moved because these items will not be added on warrant is added */
     /* else if (holder.holder=='[QR-CODE]'){
        //AUTO ADDED TO PROJECT. ITS AN IMAGE
        var hv={...holdervalues};
        var row=hv[holder.id];
        if(hv[holder.id]==null){
        //    console.log('found qrcode within document')
       // var searchlink=`DOC/JS/${item.caseFeeId}/${item.id}/${currectdoc?.id}`; 
        var searchlink=(item.type=='affidavit'  )? `${Constants.baseurl}/search/${affidavit_search_prefix}/${currectdoc?.upline?.id}/${retrieveDocYear()}}`:`${Constants.baseurl}/search/${item.caseNumber}/HC/${currectdoc?.upline?.id}}`;
        var urlimg = Constants.QrCodelink(searchlink) ;
        onAppendStoreImg(holder,urlimg); //Write qrcode straing
        }
        
    }
    else if (holder.holder=='[CASHIER_SEAL]'){
        //AUTO ADDED TO PROJECT. ITS AN IMAGE
        var hv={...holdervalues};
        var row=hv[holder.id];
        if(hv[holder.id]==null){
          //  console.log('found qrcode within document')
       // var searchlink=`DOC/JS/${item.caseFeeId}/${item.id}/${currectdoc?.id}`; 
        var cashierlink=`${Constants.rooturl}/resources/special/cashier_seal_${currectdoc?.upline?.id}.png`
        var urlimg = cashierlink ;
        onAppendStoreImg(holder,urlimg); //Write qrcode straing
        }
        
    }
    else if (holder.holder=='[CASHIER_STAMP]'){
        //AUTO ADDED TO PROJECT. ITS AN IMAGE
        var hv={...holdervalues};
        var row=hv[holder.id];
        if(hv[holder.id]==null){
       //     console.log('found qrcode within document')
       // var searchlink=`DOC/JS/${item.caseFeeId}/${item.id}/${currectdoc?.id}`; 
        var cashierlink=`${Constants.rooturl}/resources/special/cashier_stamp.png`
        var urlimg = cashierlink ;
        onAppendStoreImg(holder,urlimg); //Write qrcode straing
        }
        
    } */
    
    else{
       // hv[ind]={value:'', type:'text'}
       // setHolderValues(hv);
        return <div>
         
        <div className="input-create">
        <label htmlFor="doc-title">{holder.name} </label>
        <input type='text' value={onGetValue(ind)} onChange={(e)=> onDirectText(e,holder,ind)} placeholder={holder.hint} />
    </div>
        </div>
    }
    
}



const onAppendStoreImg=(holder, imgpath)=>{
  //  console.log(`the holder  ${holder.id}`)
    //check which type of item
//if signature, no gree, if seal no gree

    if(holder.dataType=='UPLOADED MEDIA[SEAL-COMISSIONER]' || holder.dataType== "UPLOADED MEDIA[SEAL-DEPONENT]"){ //for seal
        if(isLegal){
            if((permissionList.has(currectdoc?.upline?.gazetteItemId) ||  item.type=='affidavit') && !currectdoc?.allowSeal){
                setAlert(  {icon:'warning',open:true,title:'Append ', subtitle:'Wait for the CFO to authorize appending a seal on the document. This approval will be granted during the scheduled virtual call', onOk});
              return;
            } 
           }else{
            if((permissionList.has(currectdoc?.upline?.gazetteItemId) ||  item.type=='affidavit') && !currectdoc?.upline?.allowSeal){
                setAlert(  {icon:'warning',open:true,title:'Append ', subtitle:'Allow Legal Counsel to append seal before you, if you sure you have as CFO then. Please Next and Previous to same file to refresh', onOk});
              return;
            } 
           }
        }

        if(holder.dataType=='UPLOADED MEDIA[SIGNATURE-DEPONENT]' || holder.dataType=="UPLOADED MEDIA[SIGNATURE-COMISSIONER]"){
            if((permissionList.has(currectdoc?.upline?.gazetteItemId)||  item.type=='affidavit') && !currectdoc?.upline?.allowSign){
                //  setAlert(  {open:true,title:'Append ', subtitle:'Wait for the CFO to authorize appending a signature on the document. This approval will be granted during the scheduled video virtual call". if you are sure the CFO has approved. Please click Next and Previous to the same file to refresh', onOk});
               setAlert(  {icon:'warning',open:true,title:'Append ', subtitle:'Wait for the CFO to authorize appending a signature on the document. This approval will be granted during the scheduled virtual call', onOk});
                return;
              } 
        }

    var hv={...holdervalues};
    var row=hv[holder.id];
    if(hv[holder.id]==null){
        hv[holder.id]={...holder, value:imgpath, type:'media'};
    }else{
        hv[holder.id]={...row,  value:imgpath, };
    }

    setHolderValues(hv);

     replaceTemplate(hv);
}
const checkMedia=(hh)=>{
    //return object {status: true, imgpath: ''}, or {status:false}
    //seal==''? Seal : seal
    var holdertype=hh.dataType;
    if(hh.holder=='[CFO_SEAL]' || hh.holder=='[DEPONENT-SEAL]'){
        return {status:seal!='', imgPath: seal, type:'Seal'}; //this will return true if seal contain value else it will return false
    }else if(hh.holder=='[CFO_INITIAL]'){
        return {status:initial!='', imgPath: initial, type:'Initial'};
    }else if(hh.holder=='[CFO_STAMP]'){
        return {status:stamp!='', imgPath: stamp, type:'Stamp'};
    }else if(hh.holder=='[SIGNATURE-DEPONENT]' || hh.holder=='[LEGAL-COUNSEL-SIGNATURE]'){
        //sign==''? Sign:sign
        return {status:sign!='', imgPath: sign, type:'Signature'};
    }
    else if(hh.holder=='[PASSPORT]'){
        return {status:passport!='', imgPath: passport, type:'Passport'};
    }else{
        return {status:false};
    }

}

        const onDirectText = (e,holder)=>{
          //  console.log(`the holder  ${holder.id}`)
            var str= Constants.ConvertText (e.target.value);
            //var str= e.target.value?.toUpperCase();
            const value= str;
            var hv={...holdervalues};
            var row=hv[holder.id];
            if(hv[holder.id]==null){
                hv[holder.id]={...holder, value:value, type:'single'};
            }else{
                hv[holder.id]={...row,  value:value, };
            }
    
            setHolderValues(hv);
          //  console.log(hv);
           
       
             replaceTemplate(hv);
             setIsSaved(false);
        }
        const onTimeStamp = (holder)=>{
           // console.log(`the holder  ${holder.id}`)
            var hv={...holdervalues};
            var row=hv[holder.id];
             const currentdate=new Date();
             //console.log(currentdate);
             var tstamp=moment(currentdate).format("YYYY-MM-DD hh:mm a");
            if(hv[holder.id]==null){
             //   console.log('first time here');

                hv[holder.id]={...holder, value:tstamp, type:'single'};
            }else{
              //  console.log(`old value ${hv[holder.id].value} and new value is ${tstamp}` )
                hv[holder.id]={...row,  value:tstamp, };
              //  console.log('another time here');
            }
           
          /*    var ftempid= currectdoc.selectedTemplate.split('|')[0];
             var htmlstr=atob(templates[ftempid].html)
             var rhtml=htmlstr ;//.replace(holder,e.target.value)
 */
            setHolderValues(hv);
       
             replaceTemplate(hv);
             setIsSaved(false);
        }

        const onDirectTextMultiple = (e,holder)=>{
        
            var hv={...holdervalues};
            const value= Constants.ConvertText(e.target.value?.toUpperCase())
            var row=hv[holder.id];
            if(hv[holder.id]==null){
                hv[holder.id]={...holder, value,  type:'list'};
            }else{
                 hv[holder.id]={...row,  value};
            }
           
            
            setHolderValues(hv);
            setIsSaved(false);
           // console.log(hv);

        }

        const onDirectAreaMultiple = (e,holder)=>{
            var hv={...holdervalues};
            var row=hv[holder.id];
            var value=Constants.ConvertText(e.target.value)
            if(hv[holder.id]==null){
                hv[holder.id]={...holder, value,  type:'paragraph'};
            }else{
                 hv[holder.id]={...row,  value};
            }
           
            
            setHolderValues(hv);
          //  console.log(hv);
            setIsSaved(false);
        }

        const onDirectDate = (e,holder,index)=>{

        }
        const onGetValue=(holder)=>{
            return holdervalues[holder.id]?.value;
        }

        const replaceTemplate=(obj)=>{
            if(currectdoc.template==null)
                return;

          // console.log(`inside the replaceTemplate function`)
             var htmlstr=Constants.b64decode(currectdoc.template.html)
             var rhtml=htmlstr ;
           
            for (const ho of Object.values(obj)){
              //  console.log(`inside the for ${ho.type}-${ho.holder}`)
                if(ho.type=='single'){
                    rhtml = Constants.ReplaceAll(rhtml,ho.holder,ho.value) 
                  
                    rhtml= rhtml.replace(/(?:\r\n|\r|\n)/g, '<br>')
                }else if(ho.type=='media'){
                   // var rp=`<table style='width:150px;display:inline'><tr><td><img src='${ho.value}' alt="Seal" style='width:100px' /></td><tr></table>`;
                   var rp=`<img src='${ho.value}' style='width:100px' />`;
                    rhtml = Constants.ReplaceAll(rhtml,ho.holder,rp) 
                }
                else if(ho.type=='list'){
                    if(ho.listobj!=null){
                        var sul='<div style="margin-left:25px; padding:16px">';
                        var idx=0;
                        for(const li of ho.listobj)
                        {
                            idx++;
                            sul+=`<p>${idx}. ${li}</p>`;
                        }
                        sul+='</div>'
                        rhtml = Constants.ReplaceAll(rhtml,ho.holder,sul) ;
                    }

                }else if(ho.type=='paragraph'){
                    if(ho.listobj!=null){
                        var sul='<div style="margin-left:25px; padding:16px">';
                        var idx=0;
                        for(const li of ho.listobj)
                        {
                            idx++;
                            sul+=`<div>${idx}. ${li.value}`

                            if(li.subs!=null)  {
                                var idxx=0;
                              sul+=  '<div style="margin-left:25px;">' 
                                for (const sub of li.subs ){
                                    idxx++;
                                    sul+=`<p>${Constants.getAlphaByNum(idxx) }). ${sub}</p>`;
                                }
                              sul+='</div>'  
                            } 
                            sul+='</div>';
                            
                        }
                        sul+='</div>'
                        rhtml = Constants.ReplaceAll(rhtml,ho.holder,sul) ;
                    }

                }else{

                }
            }
           // console.log('at point of replace *******')
            setHtml(rhtml );
        }

        const onFinalProcess=async()=>{
            //write the txt to pdf
            setIsDialog(false)
            try {
                const theurl=`${Constants.apiUrl}/filing/saveTemplateData/${currectdoc.upline.id}`;
                setIsLoading(true);
                var strjson=btoa(JSON.stringify(holdervalues)) ;
                var base64 =Constants.b64encode(html); // btoa(html);
                const data={docuplineId:currectdoc.upline.id,htmlstr: base64,jsonstr:strjson,
                   doctype, Userid:profile.username, isFinal:true};
                const resp = await fetch(theurl, {
                  method: 'POST',
                  body: JSON.stringify(data),
                  headers: {
                    'Content-Type': 'application/json',
                   Authorization: `Bearer ${token}`,
                  },
                });
                
                const responseData = await resp.json();
                setIsLoading(false);
          //      console.log('here1');
         //       console.log(responseData);
                if (responseData.code == 0 ) {
                   // alert('saved to a pdf file');

                   // setAlert(  {open:true,title:'Template', subtitle:'saved to a pdf file', onOk});

                    if(responseData.incompleted==0){
                        setAlert( {...alert, title:'Process Document', open:true, subtitle: onfinalMsg(), onOk:onIsCompleted })
                    }else{
                        setAlert( {...alert, title:'Process Document', open:true, subtitle:`Processed Successfully. Document remain to be processed ${responseData.incompleted}`, onOk })
                    }

                    setIsSaved(true);
                   // setAllDocCompleted(responseData.isFinal);
                   
                    
                }else if(responseData.code==-10){
                      setIsExpired(true);
                  }else {
                    setAlert(  {open:true,title:'Template', subtitle:responseData.status, onOk});
                }
              
              } catch (error) {
                setIsLoading(false);
                console.error(error);
               
              }
        }

        const onfinalMsg=()=>{
            if(item.type=='affidavit'){
                return finalmsgaffidavit;
            }else if(doctype=='sheriff'){
               return finalmssheriff
            }else if(doctype=='settlement'){
               return finalsettlement

            }else if(doctype=='service-sheriff-sub')
                return "You have worked on all doument(s). The case will now move to Case manger Queue"; 
            else{
               return finalmsgcase
            }
        }

        const onSaveMsg=()=>{
            if((permissionList.has(currectdoc?.upline?.gazetteItemId)||  item.type=='affidavit')){
                return needpermission;
            }else if(doctype=='sheriff'){
               return finalmssheriff
            }else if(doctype=='settlement'){
               return finalsettlement
              
            }else if(doctype=='service-sheriff-sub')
                return "Document saved successfully! "; 
            else{
               return needpermission
            }
        }

        const onSaveDraft =async()=>{
            //write the txt to pdf
            setIsDialog(false)
            //this will save only item added

            try {
                const theurl=`${Constants.apiUrl}/filing/saveTemplateData/${currectdoc.upline.id}`;
                setIsLoading(true);
                var stfy=JSON.stringify(holdervalues)
                var strjson= Constants.b64encode(stfy) ;
             //   console.log('json values of selected values ');
               // console.log(stfy);
                //var strhtml=btoa();

            //    console.log('possible html to btoa');
               // console.log(html);
                var base64 =Constants.b64encode(html);
                const data={docuplineId:currectdoc.upline.id,jsonstr:strjson,htmlstr: base64,  
                    doctype,Userid:profile.username,isFinal:false};
                const resp = await fetch(theurl, {
                  method: 'POST',
                  body: JSON.stringify(data),
                  headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                  },
                });
                const responseData = await resp.json();
                setIsLoading(false);
                if (responseData.code == 0 ) {
                   // alert('saved to a pdf file');
                    setAlert(  {open:true,title:'Document', subtitle:onSaveMsg(), onOk:onOk_Save});
                    setIsSaved(true);
                    
                }else if(responseData.code==-10){
                      setIsExpired(true);
                  }else {
                    setAlert(  {open:true,title:'Document1', subtitle:responseData.status, onOk});
                }

                setIsSaved(true);
              } catch (error) {
                setIsLoading(false);
                console.error(error);
               
              }
        }

        const onProcessAction=()=>{
            //check if all item is entered for on the 
           // holdervalues
           const arrMain=Object.values(holdervalues);
           //compare if holders.length is same figure arrMains
           //arrMain.length== holders.length
           if(isLegal){
             //completed but still check 
             onSaveDraft();
             
           }else{
            onFinalProcess();

           }

        }

      const cancelUpload=()=>{
        setUpload({open:false});

      }

      const onIsCompleted=()=>{
        // go to home page, when work is completed
       // console.log('is completed')
        setAlert({...alert,open:false});
       // window.location.replace(`${Constants.primarySite}/Users.aspx`)
       if(item.type=='affidavit'){
        navigate("/templates/AffidavitDocuments");
       }else if (doctype=='sheriff'){
             navigate("/cfo-e-swearing-sheriff");
       }
       else{
        navigate("/cfo-e-swearing")
       }
        
    }

    useEffect(() => {
        replaceTemplate(holdervalues);
     /*  if(refresh){
        setTimeout(function () {
            //setBttnText("COPY CODE");
           
          }, 1000);
       setRefresh(false);
    } */
     }, [html,refresh, holdervalues]); 

   
    const retrieveDocYear=()=>{
     return currectdoc?.upline.uploadDate==null ? moment(new Date()).format("YYYY"): moment(currectdoc?.upline.uploadDate).format("YYYY")
    }

  return (
    <div style={{width:'100%'}}>

        <div className="body" style={{width:'100%'}}>

            <div className="document">
                <div className="doc-side">
                    <div className="top-bar">
                     
                        <div className="namedoc">
                            <p>Template: <span>{currectdoc.template.title}</span> </p>
                        </div>
                       
                    </div>  
                    <div className="wrapper" style={{maxWidth:750, width:'100%', backgroundColor:'white',color:'black', padding:0, position:'relative', overflow:"auto"}}
                      >
                      <div  className='htmlwrap' dangerouslySetInnerHTML={{__html:  html}}></div>
                      
                      
                    </div>
                </div>
               
                 <div className='actions'>


                    <div className='create-case'>
                        
                        <div className="body">
                            <div className="top-nav">
                                <div className="left-top">
                                   
                                    
                    
                      
                   
                                </div>
                                <p className="nav-status"></p>
                            </div>
                            <div className="form">
                                <div className="left-side">
                                   
                                    {holders.length>0 && holders?.map((ho, idx) => { return (
                                        ((isLegal && !Constants.CFO_Placeholders.has(ho.id)) || !isLegal && Constants.CFO_Placeholders.has(ho.id))
                                        &&
                                    
                                          returnTag(ho, idx)
                                
                                        )})}
                                </div>
                              
                            </div>
                            <div className="down">
                              
                               {/*  <div >
                                    <JisButton onClick={()=> setIsDialog(true)}
                                    
                                    >
                                       {(isLegal)? 'Save Document':"Process Document"} 
                                        <DynamicIcon iname='arrow_right'/>
                                    </JisButton>
                                </div> */}
                            </div>
                        </div>
                    </div>
                   
                   
                    
                    
                    
                </div>
            </div>
            <div className="down">
              
               
                 
   
                { isThirdOpt && <button onClick={() => confirmCaseDoc()}>Confirm Document</button> }
            </div>
        </div>
      {cfoWarn && <div className={   'warning show' }>
            <div className="container">
                <div className="icon" onClick={() => setCfoWarn(false)}>
                     <DynamicIcon iname='close'/>
                </div>
                <div className="body">
                    <h3>Appending Signature</h3>
                    <p>You are not allowed to upload your signature yet. Please wait for the Chief for Oath (CFO) authorizes you to upload your signature. In the mean time, you can upload your seal and passport </p>
                    <button onClick={() => setCfoWarn(false)}>Ok</button>
                </div>
            </div>
        </div> }  
     
        <BackLoader open={isLoading}  />
        {alert.open && <JisAlert {...alert} />} 
        <JisPrompt  open={isDialog} onOk={onProcessAction} onCancel={()=>setIsDialog(false)}>
            <p style={{flexDirection:'row', alignContent:'center', alignItems:'center'}}>
           
               {(profile.role=='LegalCounsel' || profile.role== 'Customer')?
               <strong>Are you sure you want to save this template ? You will not be able to amend after the Commissioner for Oaths has worked on it</strong>:
            <strong>Are you sure you want to process this template ?</strong>}

            
            </p>
        </JisPrompt>

      

      {upload.open &&  <JisDialogForm title="Upload" onClose={cancelUpload}>
                      <div className="upload-wrap">
                <h3>{upload.title}</h3>
                <div className="upload-file-btn">
                   
                    <input
                        type="file"
                        id="upload-input"
                        accept="image/*"
                        onChange={previewImage}
                    />
                     {upload.isImage && (
                        <img src={upload.data} style={{height:100}} alt="Uploaded Media" />
                        )}
                </div>  

                <p className="warn">Maximum File Upload: 1mb</p>

             

                
                <JisButton icon="check_circle" onClick={onSaveInst}>Upload</JisButton>
                <JisButton variant='default' onClick={() => cancelUpload()}>Cancel</JisButton>
            </div>  
        </JisDialogForm>}  

        {activeSub.open && <JisDialog title={activeSub.title}>
            <div className="upload-wrap">
              
               
                    
                    <textarea value={activeSub.value} style={{width:'100%', height:100, padding:16}} onChange={(e)=>setActiveSub({...activeSub, value: Constants.ConvertText(e.target.value) })}>
                    </textarea>
                    
                    
               

              

                
                <button icon="check_circle" onClick={onAddSubPara}>Add Sub Paragraph</button>
                <button className='red' onClick={() => setActiveSub({open:false})}>Cancel</button>
            </div>
        </JisDialog>} 

    
    </div>
  )
}

export default JisPrepareTemplatePlain